/** Named swatch sets shown in the Color panel. */

export interface ColorPalette {
  id: string;
  label: string;
  /** CSS hex colours, usually 16–24. */
  colors: readonly string[];
}

export const COLOR_PALETTES: readonly ColorPalette[] = [
  {
    id: 'classic',
    label: 'Classic',
    colors: [
      '#000000',
      '#404040',
      '#808080',
      '#c0c0c0',
      '#ffffff',
      '#7f0000',
      '#ff0000',
      '#ff7f00',
      '#ffff00',
      '#7fff00',
      '#00ff00',
      '#00ff7f',
      '#00ffff',
      '#007fff',
      '#0000ff',
      '#7f00ff',
      '#ff00ff',
      '#ff007f',
      '#8b5a2b',
      '#f5deb3',
    ],
  },
  {
    id: 'zinc',
    label: 'Zinc',
    colors: [
      '#09090b',
      '#18181b',
      '#27272a',
      '#3f3f46',
      '#52525b',
      '#71717a',
      '#a1a1aa',
      '#d4d4d8',
      '#e4e4e7',
      '#fafafa',
      '#f87171',
      '#fb923c',
      '#fbbf24',
      '#a3e635',
      '#34d399',
      '#22d3ee',
      '#60a5fa',
      '#a78bfa',
      '#f472b6',
      '#e7e5e4',
    ],
  },
  {
    id: 'warmFilm',
    label: 'Warm Film',
    colors: [
      '#1a1210',
      '#2c1e18',
      '#4a3228',
      '#6b4a38',
      '#8c6550',
      '#b08968',
      '#d4a574',
      '#e8c9a0',
      '#f5e6d3',
      '#fff8f0',
      '#5c1f1a',
      '#8b3a2a',
      '#c45c26',
      '#e07a3d',
      '#f0a05a',
      '#3d4a3a',
      '#5a6b52',
      '#7a8f6e',
      '#2a3a48',
      '#4a6578',
    ],
  },
  {
    id: 'coolCinema',
    label: 'Cool Cinema',
    colors: [
      '#0b1020',
      '#141c2e',
      '#1e2a40',
      '#2d3d55',
      '#3f5470',
      '#5a7190',
      '#849bb8',
      '#b0c4d8',
      '#d6e4f0',
      '#f2f7fb',
      '#1a3040',
      '#2a5568',
      '#3d7a8c',
      '#5aa0b0',
      '#8ec8d4',
      '#4a2840',
      '#7a3d5c',
      '#b85a78',
      '#e8a090',
      '#f5d0c0',
    ],
  },
  {
    id: 'sunset',
    label: 'Sunset',
    colors: [
      '#1b0f2a',
      '#2d1840',
      '#4a2060',
      '#6b2d7a',
      '#9a3a6a',
      '#c94a4a',
      '#e86a3a',
      '#f59a3a',
      '#ffc14a',
      '#ffe8a0',
      '#fff5d6',
      '#3a2048',
      '#5c3868',
      '#8a5078',
      '#c07080',
      '#e09890',
      '#f0c0a8',
      '#204050',
      '#386878',
      '#68a0a8',
    ],
  },
  {
    id: 'ocean',
    label: 'Ocean',
    colors: [
      '#021820',
      '#043040',
      '#064858',
      '#0a6070',
      '#0e8898',
      '#20a8b0',
      '#48c8c0',
      '#78e0d0',
      '#b0f0e8',
      '#e8fffa',
      '#0a2838',
      '#164860',
      '#286888',
      '#3a88a8',
      '#60b0c8',
      '#c8a070',
      '#e0c090',
      '#f0dcb0',
      '#806040',
      '#a88858',
    ],
  },
  {
    id: 'forest',
    label: 'Forest',
    colors: [
      '#0c140c',
      '#1a2818',
      '#2a3c28',
      '#3c5438',
      '#527048',
      '#6a8c5a',
      '#8ab070',
      '#a8c888',
      '#c8e0a8',
      '#e8f5d0',
      '#3a2a18',
      '#5c4028',
      '#7a5838',
      '#9a7848',
      '#c0a068',
      '#204040',
      '#386060',
      '#508878',
      '#78b098',
      '#a8d0b8',
    ],
  },
  {
    id: 'portrait',
    label: 'Portrait',
    colors: [
      '#1a1210',
      '#2e2018',
      '#4a3428',
      '#6b4e3a',
      '#8f6a4e',
      '#b89070',
      '#d4b090',
      '#e8cbb0',
      '#f5e0d0',
      '#fff5f0',
      '#5a2830',
      '#8a4048',
      '#b86868',
      '#d49088',
      '#e8b8a8',
      '#3a3048',
      '#5a5070',
      '#8070a0',
      '#a898c0',
      '#c8c0d8',
    ],
  },
  {
    id: 'pastel',
    label: 'Pastel',
    colors: [
      '#2a2a30',
      '#f7f4ef',
      '#f2d7d9',
      '#f6c6c8',
      '#f8d9b8',
      '#f5e6a8',
      '#d8ecc8',
      '#c4e8d8',
      '#c0e0f0',
      '#c8d0f0',
      '#d8c8f0',
      '#e8c8e0',
      '#e8b8c8',
      '#d0b8a8',
      '#b8c8b0',
      '#a8c0c8',
      '#b0b0c8',
      '#c8b8c0',
      '#e0d0c0',
      '#908890',
    ],
  },
  {
    id: 'neonNight',
    label: 'Neon Night',
    colors: [
      '#050508',
      '#0e0e18',
      '#1a1428',
      '#241838',
      '#ff2d55',
      '#ff6b35',
      '#ffcc00',
      '#39ff14',
      '#00f5d4',
      '#00bbf9',
      '#9b5de5',
      '#f15bb5',
      '#fee440',
      '#00f5a0',
      '#7b2cbf',
      '#e0aaff',
      '#48cae4',
      '#90e0ef',
      '#ffffff',
      '#adb5bd',
    ],
  },
  {
    id: 'earth',
    label: 'Earth',
    colors: [
      '#1c1410',
      '#3b2f2f',
      '#5c4033',
      '#7b5e57',
      '#a67c52',
      '#c4a484',
      '#d2b48c',
      '#e6d5b8',
      '#f5efe6',
      '#fffaf0',
      '#4a5d23',
      '#6b8e23',
      '#8fbc8f',
      '#556b2f',
      '#8b4513',
      '#a0522d',
      '#cd853f',
      '#daa520',
      '#2f4f4f',
      '#708090',
    ],
  },
  {
    id: 'bwPrint',
    label: 'B&W Print',
    colors: [
      '#000000',
      '#111111',
      '#222222',
      '#333333',
      '#444444',
      '#555555',
      '#666666',
      '#777777',
      '#888888',
      '#999999',
      '#aaaaaa',
      '#bbbbbb',
      '#cccccc',
      '#dddddd',
      '#eeeeee',
      '#ffffff',
      '#1a1a1a',
      '#4d4d4d',
      '#b3b3b3',
      '#e6e6e6',
    ],
  },
];

export const DEFAULT_PALETTE_ID = COLOR_PALETTES[0]!.id;

export function paletteById(id: string): ColorPalette {
  return COLOR_PALETTES.find((palette) => palette.id === id) ?? COLOR_PALETTES[0]!;
}
